module.exports = __webpack_public_path__ + "static/media/18.9733b336.jpg";